import { render, staticRenderFns } from "./TeamArea.vue?vue&type=template&id=39109c72&"
import script from "./TeamArea.vue?vue&type=script&lang=js&"
export * from "./TeamArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports